/** 消息编解码：JSON + UTF-8，带版本字段 `v`。 */
const encoder = new TextEncoder();
const decoder = new TextDecoder();
export function encodeMessage(value) {
    return encoder.encode(JSON.stringify(value));
}
export function decodeMessage(data) {
    const text = data instanceof Uint8Array
        ? decoder.decode(data)
        : decoder.decode(new Uint8Array(data));
    return JSON.parse(text);
}
export function decodeMessageSafe(data) {
    try {
        return decodeMessage(data);
    }
    catch {
        return null;
    }
}
export function parseJson(text) {
    try {
        return JSON.parse(text);
    }
    catch {
        return null;
    }
}
//# sourceMappingURL=codec.js.map